// window.__env__ is used in deployed to kube projects
// process.env is used during local development
let envSource;

if (process.env.NODE_ENV === 'development') {
  envSource = process.env;
} else {
  envSource = window.__env__;
}

const {
  REACT_APP_CONFIG,
  REACT_APP_ACCOUNTS_URL,
  REACT_APP_B2B_SELFCARE_URL,
  REACT_APP_SMSGW_MESSAGING_URL,
  REACT_APP_SMSGW_MESSAGING_KEYCLOAK_REALM,
  REACT_APP_SMSGW_MESSAGING_KEYCLOAK_URL,
  REACT_APP_SMSGW_MESSAGING_KEYCLOAK_CLIENT_ID
} = envSource;

export default {
  accountsUrl: REACT_APP_ACCOUNTS_URL,
  b2bSelfcareUrl: REACT_APP_B2B_SELFCARE_URL,
  smsgwMessagingUrl: REACT_APP_SMSGW_MESSAGING_URL,
  keycloak: {
    realm: REACT_APP_SMSGW_MESSAGING_KEYCLOAK_REALM,
    url: REACT_APP_SMSGW_MESSAGING_KEYCLOAK_URL,
    clientId: REACT_APP_SMSGW_MESSAGING_KEYCLOAK_CLIENT_ID
  }
};

if (REACT_APP_CONFIG === 'prod' || REACT_APP_CONFIG === 'pre') {
  console.log = () => false;
  console.warn = () => false;
  console.error = () => false;
  console.group = () => false;
  console.groupEnd = () => false;
}

